// extracted by mini-css-extract-plugin
export default {"menu":"about-nav_menu__u-oxA","menu-item":"about-nav_menu-item__g3gOd"};